import { gql } from '@apollo/client';

const GET_ORDER_HISTORY = gql`
  query {
      orderHistory {
        orders {
        orderId
        orderToken
        statusDisplayText
        email
      }
    }
  }
`;

export default GET_ORDER_HISTORY;
